const danhSachVanBan = (state) => state.danhSachVanBan;
const vanBanDangCapNhat = (state) => state.vanBanDangCapNhat;
const vanBanId = (state) => state.vanBanId;
const danhSachDonViNgoai = (state) => state.danhSachDonViNgoai;

export default {
  danhSachVanBan,
  vanBanDangCapNhat,
  vanBanId,
  danhSachDonViNgoai,
};
